import { createFileRoute } from "@tanstack/react-router";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import BundleCreateForm from "./-form";
import { BundleCrumbs } from "./-crumbs";

export const Route = createFileRoute("/_private/_patient-360/bundle/create")({
  component: BundleCreatePage,
});

function BundleCreatePage() {
  return (
    <div>
      <title>Create Bundle - Legrande Health Portal</title>
      <BundleCrumbs />
      <Card>
        <CardHeader>
          <CardTitle>Create Bundle</CardTitle>
          <CardDescription>Enter bundle details below.</CardDescription>
        </CardHeader>
        <CardContent>
          <BundleCreateForm />
        </CardContent>
      </Card>
    </div>
  );
}
